<a
    role="menuitem"
    [routerLink]="['/', 'profile']"
    routerLinkActive="active"
    #rla="routerLinkActive"
    [attr.aria-current]="rla.isActive ? 'page' : null"
    [attr.aria-label]="'profile.link.aria-label' | translate: { name: fullName() }"
    data-test="nav-profile"
>
    <app-avatar [avatarSrc]="avatarSrc()" />

    <div>
        <span class="name" [title]="fullName()"> {{ fullName() }} </span>

        @if (school()?.name; as name) {
            <span class="school"> {{ name }} </span>
        }
    </div>
</a>
